import { useEffect, useRef } from "react";
import { nexusGetAnnouncements, nexusAckAnnouncements, audioUrlForKey } from "../lib/api";
import { toast } from "sonner";

// Invisible always-on listener: polls the 24/7 engine for proactive announcements,
// speaks danger ones aloud, toasts them on any Nexus screen, then acks.
export default function NexusAnnouncer({ userId }) {
  const sinceRef = useRef(new Date().toISOString());
  const audioRef = useRef(null);

  useEffect(() => {
    if (!userId) return;
    if (!audioRef.current) {
      audioRef.current = new Audio();
    }
    let stopped = false;
    const tick = async () => {
      try {
        const r = await nexusGetAnnouncements(userId, sinceRef.current);
        if (r.now) sinceRef.current = r.now;
        const items = (r.items || []).slice().reverse();
        for (const a of items) {
          const isDanger = a.level === "danger";
          (isDanger ? toast.error : toast.message)(a.title, { description: a.text, duration: 9000 });
          if (a.audio_key && audioRef.current) {
            try { audioRef.current.src = audioUrlForKey(a.audio_key); audioRef.current.play().catch(() => {}); } catch (e) {}
          }
        }
        if (items.length) nexusAckAnnouncements(userId, items.map((i) => i.id)).catch(() => {});
      } catch (e) { /* silent */ }
    };
    const t = setInterval(() => { if (!stopped) tick(); }, 20000);
    tick();
    return () => { stopped = true; clearInterval(t); };
  }, [userId]);

  return null;
}
